import axios from 'axios'
import { CHECK, LOGIN, LOGOUT, CHANGE_SERVER, CHANGE_TOKEN, CHANGE_LOGIN, CHANGE_COMPANY, CLEAR, TOKEN_REFRESH } from './mutation-types'
import { servers } from '../../helpers'
import jwtDecode from 'jwt-decode'

export default {
  [CHANGE_SERVER] (state, server) {
    state.server = server
    axios.defaults.baseURL = servers[server].platform
  },

  [CHECK] (state) {
    state.authenticated = !!state.token
    if (state.authenticated) {
      axios.defaults.headers.common.Authorization = `Bearer ${state.token}`
      axios.defaults.baseURL = servers[state.server].platform
    }
  },

  [LOGIN] (state, { token, entitlements, role, company_id: companyId, mckid_token: mckidToken, mckid_refresh_token: mckidRefreshToken }) {
    state.originalToken = state.token = token
    state.originalCompanyId = state.companyId = companyId
    state.entitlements = entitlements
    state.role = role
    state.authenticated = true
    axios.defaults.headers.common.Authorization = `Bearer ${state.token}`
    state.expDate = jwtDecode(token).exp
    state.mckidToken = mckidToken ? `bearer ${mckidToken}` : null
    state.mckidExpDate = mckidToken ? jwtDecode(mckidToken).exp : null
    state.mckidRefreshToken = mckidRefreshToken
  },

  [TOKEN_REFRESH] (state, { access_token: accessToken, refresh_token: refreshToken }) {
    state.mckidExpDate = jwtDecode(accessToken).exp
    state.mckidToken = `bearer ${accessToken}`
    state.mckidRefreshToken = refreshToken
  },

  [CHANGE_TOKEN] (state, token) {
    state.token = token
    axios.defaults.headers.common.Authorization = `Bearer ${state.token}`
    state.expDate = jwtDecode(token).exp
  },

  [LOGOUT] (state) {
    state.authenticated = false
    state.token = null
    state.originalToken = null
    axios.defaults.headers.common.Authorization = ''
    state.expDate = null
    state.code = null
    state.mckidToken = null
  },

  [CHANGE_LOGIN] (state, login) {
    state.login = login
  },

  [CHANGE_COMPANY] (state, companyId) {
    state.companyId = companyId
  },

  [CLEAR] (state) {
    state.login = null
  }
}
